import React from 'react';
import { withRouter } from 'react-router-dom';

class Grid extends React.Component {

    constructor() {

        super();

        this.state = {
            pageNum: 1,
            totalPages: 0,
            pages: [[]]
        };

        this.pageDown = this.pageDown.bind(this);
        this.pageUp = this.pageUp.bind(this);
        this.abrir = this.abrir.bind(this);

    }

    pageDown() {

        if (this.state.pageNum > 1) {
            this.setState({ pageNum: this.state.pageNum - 1 });
        }

    }

    pageUp() {

        if (this.state.pageNum < this.state.totalPages) {
            this.setState({ pageNum: this.state.pageNum + 1 });
        }

    }

    abrir(row) {

        this.props.history.push({
            pathname: this.props.linkTo,
            state: { row: row }
        });

    }

    componentDidMount() {

        let tp = this.props.data.length / this.props.pageSize;

        if (tp > parseInt(tp)) {
            this.setState({ totalPages: parseInt(tp) + 1 });
        } else {
            this.setState({ totalPages: parseInt(tp) });
        }

        let p = 0;

        for (let i = 0; i < this.props.data.length; i++) {

            if (i % this.props.pageSize === 0 && i !== 0) {

                p++;
                this.state.pages.push([]);
                this.state.pages[p].push(this.props.data[i]);

            } else {

                this.state.pages[p].push(this.props.data[i]);

            }

        }

    }

    render() {
        return(
            <div id="grid">
                <table>
                    <thead>
                        <tr>
                            { this.props.header.map((h, i) => <th key={ i }>{ h }</th> ) }
                        </tr>
                    </thead>
                    <tbody>
                        { this.state.pages[this.state.pageNum - 1].map((row, i) => 
                            <tr key={ i } onClick={ () => this.abrir(row) } >
                                { row.data.map((dt, j) => <td key={ j }>{ dt }</td>) }
                            </tr>) }
                    </tbody>
                </table><br />
                <button type="button" onClick={ this.pageDown }>
                    { '<' }
                </button>
                    <b> { this.state.pageNum } / { this.state.totalPages } </b>
                <button type="button" onClick={ this.pageUp }>
                    { '>' }
                </button>
            </div>
        );
    }

}

export default withRouter(Grid);

